import { PublicApiClient } from "../apiClient/publicApiClient";

export const getTechnicalGuides = async (apiClient: PublicApiClient | null, callId: string): Promise<object[]> => {
    if (!apiClient) {
        return Promise.reject("PublicApiClient is not initialized");
    }
    return apiClient?.request<object[]>("/technicalguide/getallforcase", {
        body: { callId },
        mockResponse: mockTechnicalGuides
    });
};

const mockTechnicalGuides = [
    {
        technicalGuideId: "470090",
        descriptions: [
            {
                description:
                    "+++ This text is machine translated +++\nTG 58102409 Kolizn\u00ed laserov\u00e1 \u0159ezac\u00ed hlava",
                language: "cs"
            },
            {
                description: "TG 58102409 Kollision Laserschneidkopf - Ursache: Auflagefl\u00e4che verschmutzt",
                language: "de"
            },
            {
                description: "TG 58102409 Collision laser cutting head - Cause: Support surface dirty",
                language: "en"
            },
            {
                description: "TG 58102409  colisi\u00f3n de Cabezal de corte l\u00e1ser  - Causa: superficie de apoyo sucia",
                language: "es"
            },
            {
                description: "TG 58102409 T\u00eate de d\u00e9coupe laser par collision - Cause : Surface de support sale",
                language: "fr"
            },
            {
                description: "TG 58102409 \u00dctk\u00f6z\u00e9ses l\u00e9zerv\u00e1g\u00f3fej - Ok: Fel\u00fclet szennyezett",
                language: "hu"
            },
            {
                description: "TG 58102409 Testa di taglio laser in collisione - causa: superficie di supporto sporca",
                language: "it"
            },
            {
                description: "TG 58102409 \u30ec\u30fc\u30b6\u30ab\u30c3\u30c6\u30a3\u30f3\u30b0\u30d8\u30c3\u30c9",
                language: "ja"
            },
            {
                description: "TG 58102409 Kolizja g\u0142owicy laserowej - Przyczyna: Zabrudzenie powierzchni przylegania",
                language: "pl"
            },
            {
                description: "+++ This text is machine translated +++\nTG 58102409 Colis\u00e3o de cabe\u00e7a de corte laser",
                language: "pt"
            },
            {
                description: "PR-C 58102409: Lazer kesme kafas\u0131nda \u00e7arp\u0131\u015fma E(%1.%2)",
                language: "tr"
            },
            {
                description:
                    "TG 58102409 \u78b0\u649e\u9433\u5c04\u5207\u5272\u982d - \u539f\u56e0\uff1a\u652f\u6490\u9762\u9ad2\u3002",
                language: "zh-Hant"
            }
        ]
    }
];
